import { Route } from '@angular/router';
import { canMatchByRole } from './core/auth/guards/can-match-by-role.guard';
import { canMatchCustomerFeature } from './core/customer/customer-feature.guard';

export const wildHarvestChildren: Route[] = [
  {
    path: '',
    redirectTo: 'tools/reports/cte-control-center',
    pathMatch: 'full',
  },
  {
    path: 'user-profile',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: [], featureKey: 'user-profile' },
    loadChildren: () => import('app/modules/user-profile/user-profile.routes').then((m) => m.userProfileRoutes),
  },
  {
    path: 'dashboards',
    redirectTo: 'tools/reports/cte-control-center',
    pathMatch: 'full',
  },
  {
    path: 'tools/reports/cte-control-center',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'control-center' },
    loadChildren: () => import('app/modules/dashboards/cte-control-center.routes').then((m) => m.cteControlCenterRoutes),
  },
  {
    path: 'tools/catch-certificate',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'wild.catch-certificate' },
    loadChildren: () => import('app/modules/tools-reports/catch-certificate/catch-certificate.routes').then((m) => m.catchCertificateRoutes),
  },
  {
    path: 'tools/tradex-catch-certificate',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'tradex.catch-certificate' },
    loadChildren: () => import('app/modules/tools-reports/tradex-catch-certificate/tradex-catch-certificate.routes').then((m) => m.tradexCatchCertificateRoutes),
  },
  {
    path: 'tools/reports/event-summary',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'event-summary' },
    loadChildren: () => import('app/modules/tools-reports/event-summary/event-summary.routes').then((m) => m.eventSummaryRoutes),
  },
  // {
  //   path: 'tools/reports/bol-summary',
  //   canMatch: [canMatchCustomerFeature, canMatchByRole],
  //   data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'bol-summary' },
  //   loadChildren: () => import('app/modules/tools-reports/bol-summary/bol-summary.routes').then((m) => m.bolSummaryRoutes),
  // },
  {
    path: 'tools/traceability/trace',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY'], featureKey: 'lot-tracing' },
    loadChildren: () => import('app/modules/tools-reports/traceability/traceability.routes').then((m) => m.traceabilityRoutes),
  },
  {
    path: 'tools/traceability/lot-sharing',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY'], featureKey: 'lot-sharing' },
    loadChildren: () => import('app/modules/tools-reports/lot-sharing/lot-sharing.routes').then((m) => m.lotSharingRoutes),
  },
  {
    path: 'tools/traceability/lot-generator',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY'], featureKey: 'lot-generator' },
    loadChildren: () => import('app/modules/tools-reports/lot-generator/lot-generator.routes').then((m) => m.lotGeneratorRoutes),
  },
  {
    path: 'tools/reports/storage-retail-summary',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'storage-retail-summary' },
    loadChildren: () => import('app/modules/tools-reports/storage-retail-summary/storage-retail-summary.routes').then((m) => m.storageRetailSummaryRoutes),
  },
  {
    path: 'ctes/fishing-landing',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'wild.fishing-landing' },
    loadChildren: () => import('app/modules/CTEs/fishing-landing/fishing-landing.routes').then((m) => m.fishingLandingRoutes),
  },
  {
    path: 'ctes/fishing',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'wild.fishing' },
    loadChildren: () => import('app/modules/CTEs/fishing/fishing.routes').then((m) => m.fishingRoutes),
  },
  {
    path: 'ctes/on-vessel-processing',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'wild.on-vessel-processing' },
    loadChildren: () => import('app/modules/CTEs/on-vessel-processing/on-vessel-processing.routes').then((m) => m.onVesselProcessingRoutes),
  },
  {
    path: 'ctes/transshipment',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'wild.transshipment' },
    loadChildren: () => import('app/modules/CTEs/transshipment/transshipment.routes').then((m) => m.transshipmentRoutes),
  },
  {
    path: 'ctes/land-base-receipt',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'wild.land-base-receipt' },
    loadChildren: () => import('app/modules/CTEs/land-base-receipt/land-base-receipt.routes').then((m) => m.landBaseReceiptRoutes),
  },
  {
    path: 'ctes/transferring',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'wild.transfer' },
    loadChildren: () => import('app/modules/CTEs/transfer/transfer.routes').then((m) => m.transferRoutes),
  },
  {
    path: 'ctes/receive',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'wild.receive' },
    loadChildren: () => import('app/modules/CTEs/receive/receive.routes').then((m) => m.receiveRoutes),
  },
  // {
  //   path: 'ctes/butchering',
  //   canMatch: [canMatchCustomerFeature, canMatchByRole],
  //   data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'wild.butchering' },
  //   loadChildren: () => import('app/modules/CTEs/butchering/butchering.routes').then((m) => m.butcheringRoutes),
  // },
  {
    path: 'ctes/processing',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'wild.processing' },
    loadChildren: () => import('app/modules/CTEs/processing/processing.routes').then((m) => m.processingRoutes),
  },
  {
    path: 'ctes/cold-storage',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'wild.cold-storage' },
    loadChildren: () => import('app/modules/CTEs/cold-storage/cold-storage.routes').then((m) => m.coldStorageRoutes),
  },
  {
  path: 'ctes/commingling',
  canMatch: [canMatchCustomerFeature, canMatchByRole],
  data: {
    roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'],
    featureKey: 'wild.commingling',
  },
  loadChildren: () =>
    import('app/modules/CTEs/commingling/commingling.routes')
      .then((m) => m.comminglingRoutes),
},


  {
    path: 'ctes/aggregation',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'wild.aggregation' },
    loadChildren: () => import('app/modules/CTEs/aggregation/aggregation.routes').then((m) => m.aggregationRoutes),
  },
  {
    path: 'ctes/disaggregation',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'wild.disaggregation' },
    loadChildren: () => import('app/modules/CTEs/disaggregation/disaggregation.routes').then((m) => m.disaggregationRoutes),
  },
  {
    path: 'ctes/shipping',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY', 'ROLE_DATA_ENTRY'], featureKey: 'wild.shipping' },
    loadChildren: () => import('app/modules/CTEs/shipping/shipping.routes').then((m) => m.shippingRoutes),
  },
  {
    path: 'aux/hatchery',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: [], featureKey: 'aux.hatchery' },
    loadChildren: () => import('app/modules/auxiliary-data/hatchery-data/hatchery-data.routes').then((m) => m.hatcheryDataRoutes),
  },
  {
    path: 'aux/feed-sku',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: [], featureKey: 'aux.feed-sku' },
    loadChildren: () => import('app/modules/auxiliary-data/feed-mill-data/feed-mill-data.routes').then((m) => m.feedMillDataRoutes),
  },
  {
    path: 'aux/feeding',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: [], featureKey: 'aux.feeding' },
    loadChildren: () => import('app/modules/auxiliary-data/feeding/feeding-data.routes').then((m) => m.feedingDataRoutes),
  },
  {
    path: 'aux/raceway',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: [], featureKey: 'aux.raceway' },
    loadChildren: () => import('app/modules/auxiliary-data/raceway-details/raceway-details.routes').then((m) => m.racewayDetailsRoutes),
  },
  {
    path: 'aux/cage-details',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: [], featureKey: 'aux.cage-details' },
    loadChildren: () => import('app/modules/auxiliary-data/cage-details/cage-details.routes').then((m) => m.cageDetailsRoutes),
  },
  {
    path: 'aux/vehicle',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: [], featureKey: 'aux.vehicle' },
    loadChildren: () => import('app/modules/auxiliary-data/vehicle-data/vehicle-data.routes').then((m) => m.vehicleDataRoutes),
  },
  {
    path: 'aux/cn-data',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: [], featureKey: 'aux.cn-data' },
    loadChildren: () => import('app/modules/auxiliary-data/cn-data/cn-data.routes').then((m) => m.cnDataRoutes),
  },
  {
    path: 'aux/vessel',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: [], featureKey: 'aux.vessel' },
    loadChildren: () => import('app/modules/auxiliary-data/vessel-data/vessel-data.routes').then((m) => m.vesselDataRoutes),
  },
  {
    path: 'master/species',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: [], featureKey: 'master.species' },
    loadChildren: () => import('app/modules/auxiliary-data/species/species.routes').then((m) => m.speciesRoutes),
  },

  {
    path: 'master/port-areas',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: [], featureKey: 'master.port-areas' },
    loadChildren: () => import('app/modules/master-data/port-areas/port-areas.routes').then((m) => m.portAreasRoutes),
  },
  {
    path: 'master/personnel',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: [], featureKey: 'master.personnel' },
    loadChildren: () => import('app/modules/master-data/personnel/personnel.routes').then((m) => m.personnelRoutes),
  },

  {
    path: 'master/certification-data',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: [], featureKey: 'master.certification-data' },
    loadChildren: () => import('app/modules/master-data/certification-data/certification-data.routes').then((m) => m.certificationDataRoutes),
  },
  {
    path: 'settings/users',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: [], featureKey: 'settings.users' },
    loadChildren: () => import('app/modules/settings/Ribena/users-roles/users-roles.routes').then((m) => m.usersRolesRoutes),
  },
  {
    path: 'settings/sharing-rules',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: [], featureKey: 'settings.sharing-rules' },
    loadChildren: () => import('app/modules/settings/Ribena/share-rule-creation/share-rule-creation.routes').then((m) => m.shareRuleCreationRoutes),
  },
  {
    path: 'settings/destination-services',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: [], featureKey: 'settings.destination-services' },
    loadChildren: () =>
      import('app/modules/settings/Ribena/destination-services-creation/destination-services.routes').then((m) => m.destinationServicesRoutes),
  },
  {
    path: 'settings/config',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: [], featureKey: 'settings.config' },
    loadChildren: () => import('app/modules/settings/Ribena/configuration/configuration.routes').then((m) => m.configurationRoutes),
  },
  {
    path: 'gdst-tools/master-data/trading-parties',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY'], featureKey: 'gdst.trading-parties' },
    loadChildren: () => import('app/modules/master-data/trading-parties/trading-parties.routes').then((m) => m.tradingPartiesRoutes),
  },
  {
    path: 'gdst-tools/master-data/locations',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY'], featureKey: 'gdst.locations' },
    loadChildren: () => import('app/modules/master-data/locations/locations.routes').then((m) => m.locationsRoutes),
  },
  {
    path: 'gdst-tools/master-data/vessels',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY'], featureKey: 'gdst.vessels' },
    loadChildren: () => import('app/modules/master-data/vessels/vessels.routes').then((m) => m.vesselsRoutes),
  },
  {
    path: 'gdst-tools/master-data/trade-items',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY'], featureKey: 'gdst.trade-items' },
    loadChildren: () => import('app/modules/master-data/trade-items/trade-items.routes').then((m) => m.tradeItemsRoutes),
  },
  {
    path: 'gdst-tools/capability-tool/tool',
    canMatch: [canMatchCustomerFeature, canMatchByRole],
    data: { roles: ['ROLE_QUALITY'], featureKey: 'gdst.capability-tool' },
    loadChildren: () => import('app/modules/GDST-tools/capability-tool/capability-tool.routes').then((m) => m.capabilityToolRoutes),
  },
];
